import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { setLimitedDialog } from '@/store/myDocuments';
import { setDailyLimitReached } from '@/store/profile';

import DailyLimitModal from './DailyLimitModal';
import { DAILY_LIMIT_ERROR_EVENT } from './utils';

export function DailyLimitModalListener() {
	const [data, setData] = useState({});

	const dispatch = useDispatch();

	const handleOpenModal = evt => {
		setData(evt.detail);
		dispatch(setLimitedDialog(true));
		dispatch(setDailyLimitReached(true));
	};

	useEffect(() => {
		window.addEventListener(DAILY_LIMIT_ERROR_EVENT, handleOpenModal);

		return () => {
			window.removeEventListener(DAILY_LIMIT_ERROR_EVENT, handleOpenModal);
		};
	}, []);

	return <DailyLimitModal data={data} />;
}
